module.exports = __webpack_public_path__ + "img/Granit Xhaka.3fabea3b.png";